import React from "react";

const WelcomeMessage: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full text-gray-600 text-center px-4">
      <div className="welcome-message" id="welcome-message">
        <h3 className="text-xl sm:text-xl md:text-2xl lg:text-3xl font-medium text-[#46ACC6] mt-2 sm:mt-4 lg:mt-6">
          Aveta System Support
        </h3>
        <p className="text-sm sm:text-base md:text-md leading-relaxed max-w-lg sm:max-w-xl md:max-w-2xl mb-4 sm:mb-6 lg:mb-8 mt-2 sm:mt-4">
          You can ask about the Aveta System or explain any issues you're
          experiencing, and we'll match your message to the best available
          answer.
        </p>
      </div>
    </div>
  );
};

export default WelcomeMessage;
